import { Injectable } from '@angular/core';

import { marcasStorage } from "./data.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {ModeloNavigationService} from "../../modelos/shared/modelo-navigation.service";
import {ModeloService} from "../../modelos/shared/modelo.service";
import {modelosStorage} from "../../modelos/shared/data.service";
import {frotasStorage} from "../../frotas/shared/data.service";
import {FrotaNavigationService} from "../../frotas/shared/frota-navigation.service";
import {FrotasService} from "../../frotas/shared/frota.service";

@Injectable()
export class MarcasService {

  constructor(
    private _modeloNavigationService: ModeloNavigationService,
    private _modeloService: ModeloService,

    private _frotaNavigationService: FrotaNavigationService,
    private _frotaService: FrotasService,

    private _autocompleteService: AutoCompleteService
  ) { }

  //session
  setSessionStorage(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(marcasStorage + '-new', object);
  }

  getSessionStorage() {
    var item: string = sessionStorage.getItem(marcasStorage + "-new");
    return JSON.parse(item);
  }

  clearSessionStorage() {
    sessionStorage.removeItem(marcasStorage + "-new");
  }

  returnToOtherForm(otherForm: string, Response: any) {
    var otherFormObject: any;
    if(Response) {
      if (otherForm === modelosStorage) {
        otherFormObject = this._modeloService.getSessionStorage();
        otherFormObject.marca = Response;
        this._modeloService.setSessionStorage(otherFormObject);
      } else if (otherForm === frotasStorage) {
        otherFormObject = this._frotaService.getSessionStorage();
        otherFormObject.modelo = {marca: Response};
        this._frotaService.setSessionStorage(otherFormObject);
      }
    }

    this._autocompleteService.clearSessionStorage(marcasStorage);

    if (otherForm === modelosStorage) {
      otherFormObject = this._modeloService.getSessionStorage();
      if (otherFormObject.id) {
        this._modeloNavigationService.goToEdit(otherFormObject.id);
      } else {
        this._modeloNavigationService.goToNew();
      }
    } else if (otherForm === frotasStorage) {
      otherFormObject = this._frotaService.getSessionStorage();
      var frotasRoute = otherFormObject.thisRoute;
      if (otherFormObject.id) {
        this._frotaNavigationService.goToEdit(otherFormObject.id, frotasRoute);
      } else {
        this._frotaNavigationService.goToNew(frotasRoute);
      }
    }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/marcas/shared/marca.service.ts
 **/